import MetricBase from "models/metrics/MetricBase";
import i18n from "i18next";
import EmptyUnit from "models/metrics/unit/EmptyUnit";
import ConversionGroup from "../../../../groups/ConversionGroup";

class MetricBookingcount extends MetricBase {
    constructor() {
        super({
            field: "metric_booking_count",
            defaultVisibility: true,
            unit: new EmptyUnit(),
            chartName: i18n.t("metrics.skyscanner.bookingcount.chartName"),
            serieLabel: i18n.t("metrics.skyscanner.bookingcount.serieLabel"),
            tooltip: i18n.t("metrics.skyscanner.bookingcount.tooltip"),
            group: new ConversionGroup(),
        });
    }
}

export default MetricBookingcount;
